import { NumberCons, StringConst } from '../../constants/const';
import { ProductItem } from '../http/prescriptionName';

export class PrescriptionName {
  num: number;
  name: string;
  isNamePrinted: number;
  diagnosis: string;
  gender: string;
  products: ProductItem[];
  dosage: string;
  birthDate: string;
  constructor() {
    this.num = NumberCons.zero;
    this.name = StringConst.empty;
    this.isNamePrinted = NumberCons.zero;
    this.diagnosis = StringConst.empty;
    this.gender = StringConst.empty;
    this.products = [];
    this.dosage = StringConst.empty;
    this.birthDate = StringConst.empty;
  }
}
